export const TimezonePickerShortcuts = {
	CloseTimezonePicker: 'escape',
};
